/* ============
 * UnderlyingAssetType Module
 * ============
 */

import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";

export default {
  state: {
    underlyingAssetTypes: [],
  },
  actions,
  getters,
  mutations
};
